import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) return null;
  
  // Always include Home as the first breadcrumb
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    ...items.filter(item => item.path !== '/')
  ];

  return (
    <nav aria-label="Breadcrumb" className="bg-gray-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 py-3">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.path} className="flex items-center">
              {index > 0 && (
                <svg 
                  className="w-5 h-5 text-gray-400 mx-2" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" 
                    clipRule="evenodd" 
                  />
                </svg>
              )}
              {index === breadcrumbs.length - 1 ? (
                <span 
                  className="text-sm font-medium text-gray-700"
                  aria-current="page"
                >
                  {crumb.name}
                </span>
              ) : (
                <Link 
                  to={crumb.path}
                  className="text-sm font-medium text-amiva-primary hover:text-amiva-accent transition-colors"
                >
                  {crumb.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      to: PropTypes.string,
    })
  ),
};

